var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusWhoWeAreTalentlenzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "talent system icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#FFFFFF",
    fillOpacity: 0.06,
    stroke: "#FFFFFF",
    strokeOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 6,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 37c1-8 5-12 12-12s11 4 12 12M9 20a5 5 0 1 0 0-10M4 34c.5-5 2.4-8 6-9M39 20a5 5 0 1 1 0-10M44 34c-.5-5-2.4-8-6-9",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusWhoWeAreTalentlenzIcon);
export default __webpack_public_path__ + "static/media/about-andus-who-we-are-talentlenz-icon.125739a45047f1270d3482f113c8aaf9.svg";
export { ForwardRef as ReactComponent };